// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const CONVERT_JSON_TO_DATASET_STEP_SHAPES = [
  {
    stepType: PipelineStepType.CONVERT_JSON_TO_DATASET,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input file': {
        systemName: 'Input file',
        displayName: 'Input file',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      Dataset: {
        systemName: 'Dataset',
        displayName: 'Dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      name: {
        kind: 'string',
        required: true
      },
      columns: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'shape',
          required: true,
          fields: {
            name: {
              kind: 'string',
              required: true
            },
            path: {
              kind: 'string',
              required: true
            },
            include: {
              kind: 'boolean',
              required: true
            },
            required: {
              kind: 'boolean',
              required: true
            }
          }
        },
        minItems: 1
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
